import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  'es': {
    common: {
      name: 'Nombre',
      description: 'Descripción',
      domain: 'Dominio',
      email: 'Email',
      password: 'Contraseña',
      role: 'Rol de usuario',
      confirmPassword: 'Confirmar contraseña',
      language: 'IDIOMA',
      logout: 'LOGOUT',
      normal: 'Normal',
      superuser: 'Super usuario',
      administrator: 'Administrador',
      color: 'Color',
      main: 'Principal',
      secundary: 'Secudary',
      content: 'Contenido',
      background: 'Fondo',
      font: 'Texto',
      share: 'Compartir y previsualizar',
      url: 'URL',
      selectImage: 'Seleccione imagen',
      QR: 'Código QR',
      submenu: 'Submenu',
      menuType: 'Tipo menu',
      search: 'Buscar',
      activityType: 'Tipo de actividad',
      today: 'Hoy',
      tomorrow: 'Mañana',
      title: 'Título',
      image: 'Imagen',
      add: 'Añadir',
      preview: 'Previsualizar',
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      ok: 'Aceptar',
      close: 'Cerrar',
      confirm: 'Confirmar',
      alias: 'Alias',
      type: 'Tipo',
      account: 'Cuenta',
      permission: 'Permisos',
      yes: 'Si',
      no: 'No',
      m0: 'Enero',
      m1: 'Febrero',
      m2: 'Marzo',
      m3: 'Abril',
      m4: 'Mayo',
      m5: 'Junio',
      m6: 'Julio',
      m7: 'Agosto',
      m8: 'Septiembre',
      m9: 'Octubre',
      m10: 'Noviembre',
      m11: 'Diciembre',
      s0: 'Lunes',
      s1: 'Martes',
      s2: 'Miércoles',
      s3: 'Jueves',
      s4: 'Viernes',
      s5: 'Sábado',
      s6: 'Domingo',
      date: 'Fecha',
      time: 'Hora'
    },
    messages: {
      required: 'Campo requerido.',
      emailValid: 'No es un email válido.',
      passwordMatch: 'Las contraseñas no coinciden.',
      updateOK: 'Actualizado correctamente',
      questionDeleted: '¿Desea eliminar completamente este contenido?',
      addToCalendar: 'Añadir al calendario',
      noActivities: 'No hay actividades para el día seleccionado'
    },
    availability: {
      isTemp: 'Es temporal',
      startDate: 'Fecha inicio',
      endDate: 'Fecha fin',
      noEndDate: 'Sin fecha fin'
    },
    menuType: {
      demo: 'Demo',
      menu: 'Menú',
      template1: 'Plantilla 1',
      template2: 'Plantilla 2',
      pdf: 'PDF',
      activities: 'Actividades',
      timeline: 'Timeline',
      socialNetworks: 'Redes sociales'
    },
    localeLabel: 'ESPAÑOL',
    signIn: 'Acceder',
    email: 'Email',
    password: 'Contraseña',
    loginError: 'Usuario o contraseña incorrectos',
    logout: 'Cerrar sesión',
    path: {
      dashboard: {
        title: 'Dashboard'
      },
      enterprises: {
        title: 'Clientes',
        subtitle: '',
        linkCommonMenus: 'Enlazar menús comunes',
        changeEnterprise: 'Cambiar a empresa'
      },
      enterprise: {
        title: 'Cliente',
        subtitle: '',
        banner: 'Banner'
      },
      users: {
        title: 'Usuarios',
        subtitle: '',
        enterpriseDefault: 'Empresa por defecto'
      },
      user: {
        title: 'Usuario',
        subtitle: ''
      },
      settings: {
        colors: 'Colores',
        logoAndCarousel: 'Logo y carrusel',
        logo: 'Logo',
        carousel: 'Carrusel',
        languages: 'Idiomas',
        fonts: 'Fuentes'
      },
      menus: {
        title: 'Menus'
      }
    },
    enterprises: 'Clientes',
    users: 'Usuarios',
    dashboard: 'Dashboard',
    menus: 'Menús',
    settings: 'Configuración',
    commonMenus: 'Menús comunes'
  },
  'en': {
    common: {
      name: 'Name',
      description: 'Description',
      domain: 'Domain',
      email: 'Email',
      password: 'Password',
      role: 'Role',
      confirmPassword: 'Confirm password',
      language: 'LANGUAGE',
      logout: 'CERRAR SESIÓN',
      normal: 'Normal',
      superuser: 'Superuser',
      administrator: 'Administrator',
      color: 'Color',
      main: 'Main',
      secundary: 'Secundary',
      content: 'Content',
      background: 'Background',
      font: 'Font',
      share: 'Share and preview',
      url: 'URL',
      selectImage: 'Select image',
      QR: 'QR code',
      submenu: 'Submenu',
      menuType: 'Menu type',
      search: 'Search',
      activityType: 'Activity type',
      today: 'Today',
      tomorrow: 'Tomorrow',
      title: 'Title',
      image: 'Image',
      add: 'add',
      preview: 'Preview',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      ok: 'OK',
      close: 'Close',
      confirm: 'Confirm',
      alias: 'Alias',
      type: 'Type',
      account: 'Account',
      permission: 'Permission',
      yes: 'Yes',
      no: 'No',
      m0: 'January',
      m1: 'February',
      m2: 'March',
      m3: 'April',
      m4: 'May',
      m5: 'June',
      m6: 'July',
      m7: 'August',
      m8: 'September',
      m9: 'October',
      m10: 'November',
      m11: 'December',
      s0: 'Monday',
      s1: 'Tuesday',
      s2: 'Wednesday',
      s3: 'Thursday',
      s4: 'Friday',
      s5: 'Saturday',
      s6: 'Sunday',
      date: 'Date',
      time: 'Time'
    },
    messages: {
      required: 'Required.',
      emailValid: 'Invalid email.',
      passwordMatch: 'Password not match.',
      updateOK: 'Updated successfully',
      questionDeleted: 'Do you want to completely remove this content?',
      addToCalendar: 'Add to calendar',
      noActivities: 'No activities'
    },
    availability: {
      isTemp: 'Is temporary',
      startDate: 'Start date',
      endDate: 'End date',
      noEndDate: 'No end date'
    },
    menuType: {
      demo: 'Demo',
      menu: 'Menu',
      template1: 'Template 1',
      template2: 'Template 2',
      pdf: 'PDF',
      activities: 'Activities',
      timeline: 'Timeline',
      socialNetworks: 'Social networks'
    },
    localeLabel: 'ENGLISH',
    signIn: 'Sign In',
    email: 'Email',
    password: 'Password',
    loginError: 'Usuario o contraseña incorrectos',
    logout: 'Logout',
    path: {
      dashboard: {
        title: 'Dashboard'
      },
      enterprises: {
        title: 'Enterprises',
        subtitle: '',
        linkCommonMenus: 'Link common menus',
        changeEnterprise: 'Change enterprise'
      },
      enterprise: {
        title: 'Enterprise',
        subtitle: '',
        banner: 'Banner'
      },
      users: {
        title: 'Users',
        subtitle: '',
        enterpriseDefault: 'Default enterprise'
      },
      user: {
        title: 'User',
        subtitle: ''
      },
      settings: {
        colors: 'Colors',
        logoAndCarousel: 'Logo and carousel',
        logo: 'Logo',
        carousel: 'Carousel',
        languages: 'Languages',
        fonts: 'Fonts'
      },
      menus: {
        title: 'Menus'
      }
    },
    enterprises: 'Enterprises',
    users: 'Users',
    dashboard: 'Dashboard',
    menus: 'Menus',
    settings: 'Settings',
    commonMenus: 'Common menus'
  }
}

const i18n = new VueI18n({
  locale: 'es', // set locale
  fallbackLocale: 'en', // set fallback locale
  messages // set locale messages
})

export default i18n
